import { render, staticRenderFns } from "./UsersRecommend.vue?vue&type=template&id=2bc7b72e&scoped=true"
import script from "./UsersRecommend.vue?vue&type=script&lang=js"
export * from "./UsersRecommend.vue?vue&type=script&lang=js"
import style0 from "./UsersRecommend.vue?vue&type=style&index=0&id=2bc7b72e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc7b72e",
  null
  
)

export default component.exports